let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9G7s9")).then(() => parcelRequire('70kLi'));